import React, { useEffect, useState } from 'react';
import useAPI from '../../../api';
import Dialog from '..';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import AddEditEventWidget from './AddEditEventWidget';
import { useAtomValue } from 'jotai';
import { userDataAtom } from '../../../Atoms';
import { checkFeature } from '../../../Router/routes';

const AppointmentDialog = function AppointmentDialog({
  open,
  onClose,
  selectedBranch,
  isOperator = false,
  onSubmit,
  hideCustomerField = false,
  title,
  defaultData = null,
}) {
  const API = useAPI();
  const userData = useAtomValue(userDataAtom);
  const [operators, setOperators] = useState([]);

  useEffect(() => {
    if (open && !isOperator && selectedBranch) {
      API.getBranchUsersByRole(
        selectedBranch.id,
        ['OPERATOR', 'SUPERVISOR', 'ADMIN'],
        (result) => {
          if (result && result.length > 0)
            setOperators(
              result.map(({ id, name, surname }) => ({
                label: `${name} ${surname}`,
                value: id,
              }))
            );
          else
            setOperators([
              {
                label: `${userData?.name} ${userData?.surname}`,
                value: userData?.id,
              },
            ]);
        },
        () => {
          setOperators([
            {
              label: `${userData?.name} ${userData?.surname}`,
              value: userData?.id,
            },
          ]);
        }
      );
    } else {
      if (checkFeature('APPOINTMENT_ASSIGNEE_FEATURE'))
        //if is operator and the feature is available
        setOperators([
          {
            label: `${userData?.name} ${userData?.surname}`,
            value: userData?.id,
          },
        ]);
      else setOperators([]);
    }
  }, [open, isOperator]);

  return (
    <Dialog
      id="appointment-dialog"
      title={title}
      icon={<CalendarMonthOutlinedIcon />}
      open={open}
      onClose={onClose}
      onCancel={onClose}
      onSubmit={onSubmit}
      width="md"
      fullWidth
      disableScroll
      form
      dividers
    >
      <AddEditEventWidget
        event={defaultData}
        hideCustomerField={hideCustomerField}
        selectedBranch={selectedBranch}
        operators={operators}
      />
    </Dialog>
  );
};

export default AppointmentDialog;
